import TableColumn from './table-column'
import { getEmptyArray } from '../../../utils'

function getSlotKey(column) {
  return column.slot || column.prop
}

function getColumnKey(column) {
  return (
    column.prop || (column.type ? `column__type__${column.type}` : `column__slot__${column.slot}`)
  )
}

function renderTableColumn(h, columns, scopedSlots) {
  return columns.map(column => {
    const props = { ...column }
    const slotKey = getSlotKey(column)
    const renderCell = scopedSlots[slotKey]
    const renderHeader = scopedSlots[`${slotKey}-header`]

    return (
      <TableColumn
        {...{
          props,
          key: getColumnKey(column),
          scopedSlots: {
            default: renderCell,
            header: renderHeader
          }
        }}
      >
        {column.children && renderTableColumn(h, column.children, scopedSlots)}
      </TableColumn>
    )
  })
}

export default {
  name: 'RenderTableColumns',
  functional: true,
  props: {
    columns: {
      type: Array,
      default: getEmptyArray
    }
  },
  render(h, ctx) {
    const {
      data,
      props: { columns }
    } = ctx

    const scopedSlots = data.scopedSlots

    return renderTableColumn(h, columns, scopedSlots)
  }
}
